// extracted by mini-css-extract-plugin
export default {"storeCard":"MovieCard_storeCard__urHJ9","storeImg":"MovieCard_storeImg__HgeOm","storeText":"MovieCard_storeText__C-KUt","storeDesc":"MovieCard_storeDesc__yDG2u"};